import { RouterProvider } from 'react-router-dom';

// project imports
import router, { routerFutureConfig } from 'routes';
import ThemeCustomization from 'themes';
import { AuthProvider } from 'contexts/AuthContext';
import { CalendarMarkersProvider } from 'contexts/CalendarMarkersContext';
import SessionReauthDialog from 'sections/auth/SessionReauthDialog';

import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <AuthProvider>
      <CalendarMarkersProvider>
        <ThemeCustomization>
          <ScrollTop>
            <RouterProvider router={router} future={routerFutureConfig} />
            <SessionReauthDialog />
          </ScrollTop>
        </ThemeCustomization>
      </CalendarMarkersProvider>
    </AuthProvider>
  );
}
